<script>
  import { mapActions, mapState } from 'vuex'
  import vueMarkdown from 'vue-markdown'
  import displayItem from '@/components/display-item'

  export default {
    name: 'compound-details',
    props: {
      compoundId: {
        type: Number,
        default: null,
        required: true
      }
    },
    components: {
      'display-item': displayItem,
      'markdown': vueMarkdown
    },
    computed: {
      ...mapState([
        'cart',
        'compoundsMap',
        'cartItems'
      ]),
      compound () {
        return this.compoundsMap[this.compoundId]
      }
    },
    methods: {
      ...mapActions([
        'aChangeCartAmount',
        'aSwitchCart'
      ]),
      changeCartAmount (row) {
        if (this.getCartId && this.cart.status !== 'opened') {
          this.$confirm('Status otwartego koszyka nie pozwala na dokonanie zmian. Czy chcesz otworzyć nowe zamówienie?', 'Uwaga', {
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            type: 'warning'
          })
            .then(() => {
              this.aSwitchCart()
              this.aChangeCartAmount({
                priceList: row.id,
                amount: row.cartAmount
              })
              this.aFetchCart()
            })
            .catch(action => {
              this.aFetchCompounds(this.pageSize)
            })
        } else {
          this.aChangeCartAmount({
            priceList: row.id,
            amount: row.cartAmount
          })
        }
      },
      checkStatus (statusList) {
        return statusList.includes(this.cart.status)
      },
      getPriceRowClass ({ row }) {
        if (row.cartAmount > 0) {
          return 'selected'
        }
        return ''
      }
    }
  }
</script>

<template>
  <div class="details">
    <div class="col-main">
      <display-item
        label="Zestaw zawiera"
        v-if="compound.isSet"
      >
        <el-table :data="compound.set">
          <el-table-column type="index"></el-table-column>
          <el-table-column
            label="nazwa"
            prop="name"
          ></el-table-column>
          <el-table-column
            label="ilość"
            align="right"
            min-width="20"
          >
            <template slot-scope="props">
              {{ props.row.amount | format_item_amount }}
            </template>
          </el-table-column>
          <el-table-column
            label="jm"
            prop="unit"
            min-width="20"
          ></el-table-column>
          <el-table-column
            label="konsystencja"
            prop="consistency"
            min-width="25"
            class-name="nowrap"
          ></el-table-column>
          <el-table-column
            label="czystość"
            prop="purity"
            min-width="25"
            class-name="nowrap"
          ></el-table-column>
        </el-table>
      </display-item>

      <display-item
        label="Informacje dodatkowe"
        v-if="compound.description || compound.informations && compound.informations.length"
      >
        <markdown>{{ compound.description }}</markdown>
        <div
          v-for="information in compound.informations"
          :key="information"
        >
          <h6> {{ compoundsMap.informations[information].name}}</h6>
          <markdown>{{ compoundsMap.informations[information].content }}</markdown>
        </div>
      </display-item>
      <display-item label="Synonimy" v-if="compound.synonyms">
        {{ compound.synonyms.replace('\n', ', ') }}
      </display-item>
      <display-item
        label="Kategorie"
        v-if="compound.categories.length"
      >
        <ul class="flat">
          <li
            v-for="category in compound.categories"
            :key="category"
          >{{ compoundsMap.categories[category].name }}
          </li>
        </ul>
      </display-item>
    </div>

    <div class="col-side">
      <el-table
        ref="pricingTable"
        :data="compound.prices"
        :row-class-name="getPriceRowClass"
      >
        <el-table-column
          label="Opakowanie"
          align="right"
          width="150"
        >
          <template slot-scope="props">
            {{ props.row.amount | format_item_amount }}&nbsp;{{
            compoundsMap.units[props.row.unit].short }}
          </template>
        </el-table-column>
        <el-table-column
          label="Cena"
          width="150"
          align="right"
        >
          <template slot-scope="props">
            {{ props.row.price | format_price }}
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          width="150"
        >
          <template slot="header">
            <i class="fa fa-cart-plus"></i>
          </template>
          <template slot-scope="scope">
            <el-input-number
              align="right"
              controls-position="right"
              placeholder="0"
              size="mini"
              v-model="scope.row.cartAmount"
              :min=0
              @change="changeCartAmount(scope.row)"
              v-if="checkStatus(['opened'])"
              :disabled="compound.isAvailable ? false : true"
            >
            </el-input-number>
            <span v-else>{{ scope.row.cartAmount | format_item_amount }}</span>
          </template>
        </el-table-column>
      </el-table>

    </div>

  </div>
</template>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/compound-details.vue